/**
 * Scroll to the position of a given node in the move list. Positions the node in the move list
 * based on the `position` param.
 */
export function scrollToNode({
  containerEl,
  moveListEl,
  nodeEl,
  position = 'center',
  onlyIfOutside = false,
}: {
  containerEl?: HTMLElement;
  moveListEl: HTMLElement;
  nodeEl: HTMLElement;
  position?: 'center' | 'nearest-edge' | 'top' | 'bottom';
  onlyIfOutside?: boolean;
}): void {
  if (!moveListEl || !nodeEl) {
    return;
  }

  // The scroll diff is BASED ON the move list dimensions, but APPLIED TO the scroll container.
  const scrollContainer = containerEl || moveListEl;

  const scrollContainerRect = scrollContainer.getBoundingClientRect();
  const nodeRect = nodeEl.getBoundingClientRect();

  if (
    onlyIfOutside &&
    scrollContainerRect.top <= nodeRect.top &&
    scrollContainerRect.bottom >= nodeRect.bottom
  ) {
    return;
  }

  switch (position) {
    case 'nearest-edge':
      scrollNodeToNearestEdge();
      break;
    case 'top':
      scrollNodeToTop();
      break;
    case 'bottom':
      scrollNodeToBottom();
      break;
    case 'center':
    default:
      scrollNodeToCenter();
  }

  /**
   * Scroll node to center of move list
   */
  function scrollNodeToCenter() {
    const halfOfScrollContainerSize = (scrollContainerRect.bottom - scrollContainerRect.top) / 2;
    const differenceFromNodeToScrollContainer =
      scrollContainerRect.top - nodeRect.top + halfOfScrollContainerSize;

    scrollContainer.scrollTop -= differenceFromNodeToScrollContainer;
  }

  /**
   * Scroll node to the nearest edge of the move list
   */
  function scrollNodeToNearestEdge() {
    const distanceToTop = nodeRect.top - scrollContainerRect.top;
    const distanceToBottom = scrollContainerRect.bottom - nodeRect.bottom;

    if (distanceToTop < distanceToBottom) {
      scrollNodeToTop();
    } else {
      scrollNodeToBottom();
    }
  }

  /**
   * Scroll node to top of move list
   */
  function scrollNodeToTop() {
    scrollContainer.scrollTop -= scrollContainerRect.top - nodeRect.top;
  }

  /**
   * Scroll node to bottom of move list
   */
  function scrollNodeToBottom() {
    scrollContainer.scrollTop += nodeRect.bottom - scrollContainerRect.bottom;
  }
}
